import { get } from 'lodash';
import { runInThisContext } from 'vm';
import { CMSConfig } from '../../shared/model/cms-model';

export class CMSConfigModel {

    optimize:CMSConfig;
    dynatrace:CMSConfig;
    biometry:CMSConfig;
    emailConfirmation:CMSConfig;
    openFinance:CMSConfig;
    limitValue:CMSConfig;
    university:CMSConfig;
    unicoSdk:CMSConfig;
    correios:CMSConfig;
    samsungCap: CMSConfig;
    keyName: CMSConfig;
    sdkVerification: CMSConfig;

    constructor(model?:any){

        if(!model){return;}

        this.optimize = new CMSConfig( get(model, 'components._onboardinglink_componente_settings_flag_optimize'));
        this.dynatrace = new CMSConfig( get(model, 'components._onboardinglink_componente_settings_flag_dynatrace'));
        this.emailConfirmation = new CMSConfig( get(model, 'components._onboardinglink_componente_settings_flag_email'));
        this.openFinance = new CMSConfig( get(model, 'components._onboardinglink_componente_settings_flag_openfinance'));
        this.limitValue = new CMSConfig( get(model, 'components._onboardinglink_componente_settings_flag_limit'));
        this.university = new CMSConfig( get(model, 'components._onboardinglink_componente_settings_flag_university'));
        this.unicoSdk = new CMSConfig( get(model, 'components._onboardinglink_componente_settings_flag_unico_sdk'));
        this.correios = new CMSConfig( get(model, 'components._onboardinglink_componente_settings_flag_express_correios'));
        this.samsungCap = new CMSConfig( get(model, 'components._onboardinglink_componente_settings_flag_samsungCap'));
        this.keyName = new CMSConfig( get(model, 'components._onboardinglink_componente_settings_flag_key_name'));
        this.sdkVerification = new CMSConfig( get(model, 'components._onboardinglink_componente_settings_flag_sdk_verification'));
    }
}
